import { render, staticRenderFns } from "./goodsOptions.vue?vue&type=template&id=7553ba56&"
import script from "./goodsOptions.vue?vue&type=script&lang=js&"
export * from "./goodsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7553ba56')) {
      api.createRecord('7553ba56', component.options)
    } else {
      api.reload('7553ba56', component.options)
    }
    module.hot.accept("./goodsOptions.vue?vue&type=template&id=7553ba56&", function () {
      api.rerender('7553ba56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/goodsOptions.vue"
export default component.exports